import { offerToken } from '../shared/offerTokens';

export type BarcodeFormat = 'text' | 'barcode_ean' | 'barcode_no_ean' | 'small_barcode_ean' | 'small_barcode_no_ean';

export interface BarcodeImage {
  url: string;
  width: number;
  height: number;
}

export interface BarcodeResult {
  token: string;
  snippet: string;
  image: BarcodeImage | null;
}

export const CARD_NUMBER_RESULT: BarcodeResult = { token: '#NUM_CARTE#', snippet: '#NUM_CARTE#', image: null };

const buildBarcodeSvgDataUri = (token: string, withEan: boolean, width: number, height: number): string => {
  const barCount = 24;
  const barsAreaHeight = height - (withEan ? 16 : 6);
  const bars = Array.from({ length: barCount }, (_, i) => {
    const x = (4 + i * ((width - 8) / barCount)).toFixed(1);
    const barWidth = i % 3 === 0 ? 2.4 : 1.2;
    const fill = i % 4 === 0 ? '#adb5bd' : '#212529';
    return `<rect x="${x}" y="3" width="${barWidth}" height="${barsAreaHeight}" fill="${fill}" />`;
  }).join('');
  const eanLabel = withEan
    ? `<text x="${width / 2}" y="${height - 3}" text-anchor="middle" font-size="9" fill="#495057" font-family="monospace">${token}</text>`
    : '';
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">`
    + `<rect width="${width}" height="${height}" fill="#fff" stroke="#adb5bd" stroke-width="1" />${bars}${eanLabel}</svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

export const buildOfferResult = (offerIndex: number, format: BarcodeFormat): BarcodeResult => {
  const token = offerToken(offerIndex);
  if (format === 'text') return { token, snippet: token, image: null };
  const isSmall = format.startsWith('small');
  const width = isSmall ? 120 : 220;
  const height = isSmall ? 44 : 70;
  const url = buildBarcodeSvgDataUri(token, format.endsWith('_ean'), width, height);
  return {
    token,
    snippet: `<img alt="${token}" src="${url}" style="max-width:${width}px;" />`,
    image: { url, width, height },
  };
};
